import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import css from '../css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Uploader from 'src/constrains/SingleImageUpload';
import { Form } from 'src/components/Antd';
import { get } from 'lodash';
const Field = Form.Item;
const imageN = 'icon';

const Icon = (props) => {
  const { disabled } = props;
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainerAll}
      rightPart={''}
      title={getI18n('storePayment.paymentEditPage.bankTransferLogo')}>
      <Field
        name={imageN}
        rules={[
          {
            required: true,
            validator: async (x, value) => {
              if (!get(value, 'uuid')) {
                return Promise.reject(
                  new Error(getI18n('general.fieldCannotEmpty')),
                );
              }
            },
          },
        ]}>
        <_Image disabled={disabled} getI18n={getI18n} />
      </Field>
    </SectionWrapper>
  );
};
export default Icon;

const _Image = (props) => {
  const { id, value, onChange, disabled, getI18n } = props;
  return (
    <ItemWrapper
      title={getI18n('storePayment.paymentEditPage.logo')}
      bottomTitle={getI18n('storePayment.paymentEditPage.recommended')}
      size='small'>
      <Uploader
        height={180}
        id={id}
        onChange={onChange}
        value={value}
        disabled={disabled}
      />
    </ItemWrapper>
  );
};
